import { render, staticRenderFns } from "./businessList.vue?vue&type=template&id=867eed48&scoped=true&"
import script from "./businessList.vue?vue&type=script&lang=js&"
export * from "./businessList.vue?vue&type=script&lang=js&"
import style0 from "./businessList.vue?vue&type=style&index=0&id=867eed48&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "867eed48",
  null
  
)

export default component.exports